import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 20px;
  border-bottom: 1px solid ${ ({ theme }) => theme.colors.greyLight };

  &:last-child {
    border-bottom: none;
  }

  .date {
    font-size: 14px;
    color: ${ ({ theme }) => theme.colors.black };
  }

  .expiration {
    font-size: 14px;
    color: ${ ({ theme }) => theme.colors.grey };
  }
`
